angular.module('impactx.rfxsupplier').controller('RFXSupplierTermsComponentCtrl', [
    'DownloadService', RFXSupplierTermsComponentController
]);

function RFXSupplierTermsComponentController(DownloadService) {
    var self = this;

    self.$onInit = function () {
        self.cardExpanded = !self.isClosed;
    };

    self.toggleCardExpansion = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        self.cardExpanded = !self.cardExpanded;
    };

    self.downloadAttachment = function (media) {
        DownloadService.openDownloadPost('/rfx/download/media', {paramName: "id", paramValue: media.id});
    };
}